import Button from 'components/button/Button';
import {getServices} from 'services/index';

const Logout = ({className = ''}: {className?: string}) => (
  <div>
    <Button
      title="Logout"
      className={`min-w-[200px] bg-error border-error/40 border ${className}`}
      onClick={() => {
        const {authService} = getServices();
        authService.logout();
      }}
    />
  </div>
);

export default Logout;
